export interface Filters {
  priceMin?: number;
  priceMax?: number;
  currency?: string;
  collabs: string[];
  skins: string[];
  legendMin?: number;
  grandMin?: number;
  collectorMin?: number;
  collectorTiers: string[];
  hasRecall?: boolean;
  hasTower?: boolean;
  hasLoading?: boolean;
  diamondsMin?: number;
  wheelMin?: number;
  rank?: string;
  server?: string;
  q?: string;
  sort: 'newest' | 'price_asc' | 'price_desc';
}

export const emptyFilters: Filters = {
  collabs: [],
  skins: [],
  collectorTiers: [],
  sort: 'newest',
};

export function buildQueryString(f: Filters, extra?: { limit?: number; cursor?: string }): string {
  const params = new URLSearchParams();
  if (f.priceMin !== undefined) params.set('priceMin', String(f.priceMin));
  if (f.priceMax !== undefined) params.set('priceMax', String(f.priceMax));
  if (f.currency) params.set('currency', f.currency);
  if (f.collabs.length) params.set('collabs', f.collabs.join(','));
  if (f.skins.length) params.set('skins', f.skins.join(','));
  if (f.legendMin !== undefined) params.set('legendMin', String(f.legendMin));
  if (f.grandMin !== undefined) params.set('grandMin', String(f.grandMin));
  if (f.collectorMin !== undefined) params.set('collectorMin', String(f.collectorMin));
  if (f.collectorTiers.length) params.set('collectorTiers', f.collectorTiers.join(','));
  if (f.hasRecall) params.set('hasRecall', 'true');
  if (f.hasTower) params.set('hasTower', 'true');
  if (f.hasLoading) params.set('hasLoading', 'true');
  if (f.diamondsMin !== undefined) params.set('diamondsMin', String(f.diamondsMin));
  if (f.wheelMin !== undefined) params.set('wheelMin', String(f.wheelMin));
  if (f.rank) params.set('rank', f.rank);
  if (f.server) params.set('server', f.server);
  if (f.q) params.set('q', f.q);
  params.set('sort', f.sort);
  if (extra?.limit) params.set('limit', String(extra.limit));
  if (extra?.cursor) params.set('cursor', extra.cursor);
  return params.toString();
}

export function countActiveFilters(f: Filters): number {
  let n = 0;
  if (f.priceMin !== undefined || f.priceMax !== undefined) n++;
  if (f.collabs.length) n++;
  if (f.skins.length) n++;
  if (f.legendMin) n++;
  if (f.grandMin) n++;
  if (f.collectorMin) n++;
  if (f.collectorTiers.length) n++;
  if (f.hasRecall) n++;
  if (f.hasTower) n++;
  if (f.hasLoading) n++;
  if (f.diamondsMin) n++;
  if (f.wheelMin) n++;
  if (f.rank) n++;
  if (f.server) n++;
  return n;
}
